import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import AdReport from './components/AdReport';

const MetaAdReportPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Meta Ad Report</h3>
      </Col>
    </Row>
    <Row>
      <AdReport />
    </Row>
  </Container>
);

export default MetaAdReportPage;
